export default __webpack_public_path__ + "static/media/user.b7dc431c.svg";